module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "学年学期",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "xnxqbm", $$v)
      },
      expression: "queryForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "课程名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "班级名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.className),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "className", $$v)
      },
      expression: "queryForm.className"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "申请教师",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.teacherName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "teacherName", $$v)
      },
      expression: "queryForm.teacherName"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "申请类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.applyType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "applyType", $$v)
      },
      expression: "queryForm.applyType"
    }
  }, _vm._l((_vm.applyInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.auditInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 申请")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.handleCellStyle,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年学期",
      "prop": "xnxqmc",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请教师",
      "prop": "creatorName",
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "班级名称",
      "prop": "className",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType",
      "formatter": _vm.applyTypeFormatter,
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason",
      "align": "center",
      "min-width": "25%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "auditState",
      "formatter": _vm.auditStateFormatter,
      "align": "center",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "15%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.auditState == '-1' && scope.row.xnxqbm == _vm.curterm) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.modRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        }), _vm._v(" 编辑\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.auditState != '-1' && scope.row.auditAuth == '0' || scope.row.xnxqbm != _vm.curterm) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.showDetailInfo(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 详情\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.auditAuth == '1' && scope.row.xnxqbm == _vm.curterm) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.auditRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 审核\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.auditState != '-1') ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showAuditList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        }), _vm._v(" 审核信息\n                    ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "customElRow",
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "1000px",
      "top": "80px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('div', {
    staticClass: "el-dialog-div"
  }, [_c('el-form', {
    ref: "curdForm",
    attrs: {
      "model": _vm.curdForm,
      "label-width": "120px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.curdRules
    }
  }, [(_vm.editType == 'new' || _vm.editType == 'edit') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择申请类型"
    },
    on: {
      "change": _vm.applyTypeChange
    },
    model: {
      value: (_vm.curdForm.applyType),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "applyType", $$v)
      },
      expression: "curdForm.applyType"
    }
  }, _vm._l((_vm.applyInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请教师",
      "prop": "applyTeacher"
    }
  }, [(_vm.userAuth.indexOf('@1@') == -1 || (_vm.editType != 'new' && _vm.editType != 'edit')) ? _c('span', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.applyTeacherName))]) : _vm._e(), _vm._v(" "), (_vm.userAuth.indexOf('@1@') > -1 && (_vm.editType == 'new' || _vm.editType == 'edit')) ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择申请教师"
    },
    on: {
      "change": _vm.applyTeacherChange
    },
    model: {
      value: (_vm.curdForm.applyTeacher),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "applyTeacher", $$v)
      },
      expression: "curdForm.applyTeacher"
    }
  }, _vm._l((_vm.teacherInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.majorholder,
      "disabled": _vm.disabled_major
    },
    on: {
      "change": _vm.applyMajorChange
    },
    model: {
      value: (_vm.curdForm.majorCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "majorCode", $$v)
      },
      expression: "curdForm.majorCode"
    }
  }, _vm._l((_vm.majorInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.classholder,
      "disabled": _vm.disabled_class
    },
    on: {
      "change": _vm.applyClassChange
    },
    model: {
      value: (_vm.curdForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "classCode", $$v)
      },
      expression: "curdForm.classCode"
    }
  }, _vm._l((_vm.classInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.courseholder,
      "disabled": _vm.disabled_course
    },
    on: {
      "change": _vm.applyCourseChange
    },
    model: {
      value: (_vm.curdForm.courseCode),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "courseCode", $$v)
      },
      expression: "curdForm.courseCode"
    }
  }, _vm._l((_vm.courseInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "调课原因",
      "prop": "adjustReason"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择调课原因"
    },
    on: {
      "change": _vm.adjustReasonChange
    },
    model: {
      value: (_vm.curdForm.adjustReason),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "adjustReason", $$v)
      },
      expression: "curdForm.adjustReason"
    }
  }, _vm._l((_vm.adjustReasonInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadButton),
      expression: "uploadButton"
    }],
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": _vm.showUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v(" 附件上传")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写变更理由",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 3,
      "show-word-limit": "",
      "maxlength": "500"
    },
    model: {
      value: (_vm.curdForm.changeReason),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "changeReason", $$v)
      },
      expression: "curdForm.changeReason"
    }
  })], 1), _vm._v(" "), (_vm.adjustFlag == '1') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原计划授课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请调整的授课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhskzcChange
    },
    model: {
      value: (_vm.curdForm.tzhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskzc", $$v)
      },
      expression: "curdForm.tzhskzc"
    }
  }, _vm._l((_vm.tzhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.tzhxqChange
    },
    model: {
      value: (_vm.curdForm.tzhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhxq", $$v)
      },
      expression: "curdForm.tzhxq"
    }
  }, _vm._l((_vm.tzhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhsjxlChange
    },
    model: {
      value: (_vm.curdForm.tzhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhsjxl", $$v)
      },
      expression: "curdForm.tzhsjxl"
    }
  }, _vm._l((_vm.tzhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "margin-left": "40px",
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.siteChange(_vm.tzhsiteList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhsiteList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhsiteList[i], "value", $$v)
        },
        expression: "tzhsiteList[i].value"
      }
    }, _vm._l((_vm.tzhsiteInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '4') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsbh))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhteaList), function(tea, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "margin-left": "40px",
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhteaList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.teaChange(_vm.tzhteaList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhteaList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhteaList[i], "value", $$v)
        },
        expression: "tzhteaList[i].value"
      }
    }, _vm._l((_vm.tzhteacherInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.sameFlag != 'true') ? _c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [(_vm.sameFlag == 'true') ? _c('span', {
      staticStyle: {
        "margin-left": "40px",
        "line-height": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name) + "  ===》")]) : _vm._e(), _vm._v(" "), (_vm.sameFlag == 'true') ? _c('el-select', {
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "filterable": "",
        "placeholder": "请选择授课地点"
      },
      on: {
        "change": function($event) {
          return _vm.siteChange(_vm.tzhsiteList[i].value, i)
        }
      },
      model: {
        value: (_vm.tzhsiteList[i].value),
        callback: function($$v) {
          _vm.$set(_vm.tzhsiteList[i], "value", $$v)
        },
        expression: "tzhsiteList[i].value"
      }
    }, _vm._l((_vm.tzhsiteInfo), function(item) {
      return _c('el-option', {
        key: item.comboValue,
        attrs: {
          "label": item.comboName,
          "value": item.comboValue
        }
      })
    }), 1) : _vm._e()], 1)
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '3') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "补课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhskzcChange
    },
    model: {
      value: (_vm.curdForm.tzhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskzc", $$v)
      },
      expression: "curdForm.tzhskzc"
    }
  }, _vm._l((_vm.tzhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.tzhxqChange
    },
    model: {
      value: (_vm.curdForm.tzhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhxq", $$v)
      },
      expression: "curdForm.tzhxq"
    }
  }, _vm._l((_vm.tzhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.tzhsjxlChange
    },
    model: {
      value: (_vm.curdForm.tzhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhsjxl", $$v)
      },
      expression: "curdForm.tzhsjxl"
    }
  }, _vm._l((_vm.tzhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择授课教师",
      "multiple": ""
    },
    model: {
      value: (_vm.curdForm.tzhskjsbh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhskjsbh", $$v)
      },
      expression: "curdForm.tzhskjsbh"
    }
  }, _vm._l((_vm.tzhteacherInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择授课地点",
      "multiple": ""
    },
    model: {
      value: (_vm.curdForm.tzhcdbh),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "tzhcdbh", $$v)
      },
      expression: "curdForm.tzhcdbh"
    }
  }, _vm._l((_vm.tzhsiteInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '2') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "停课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择周数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhskzcChange
    },
    model: {
      value: (_vm.curdForm.yjhskzc),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhskzc", $$v)
      },
      expression: "curdForm.yjhskzc"
    }
  }, _vm._l((_vm.yjhskzcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择星期"
    },
    on: {
      "change": _vm.yjhxqChange
    },
    model: {
      value: (_vm.curdForm.yjhxq),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhxq", $$v)
      },
      expression: "curdForm.yjhxq"
    }
  }, _vm._l((_vm.yjhxqInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择节数",
      "multiple": ""
    },
    on: {
      "change": _vm.yjhsjxlChange
    },
    model: {
      value: (_vm.curdForm.yjhsjxl),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "yjhsjxl", $$v)
      },
      expression: "curdForm.yjhsjxl"
    }
  }, _vm._l((_vm.yjhsjxlInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "line-height": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc))])])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editType == 'audit' || _vm.editType == 'show') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请类型",
      "prop": "applyType"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.applyTypeName) + "\n                                ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请教师",
      "prop": "applyTeacher"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.applyTeacherName) + "\n                                ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业名称",
      "prop": "majorCode"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.majorName) + "\n                                ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.className) + "\n                                ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课程名称",
      "prop": "courseCode"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.courseName) + "\n                                ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "调课原因",
      "prop": "adjustReason"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.curdForm.adjustReasonName) + "\n                                    "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadButton),
      expression: "uploadButton"
    }],
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": _vm.showUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload2"
  }), _vm._v(" 附件上传")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "变更理由",
      "prop": "changeReason"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "50px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.curdForm.changeReason) + "\n                            ")])]), _vm._v(" "), (_vm.adjustFlag == '1') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原计划授课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskzc + ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(parseInt(_vm.curdForm.yjhxq, 10)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请调整的授课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.tzhskzc + ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(parseInt(_vm.curdForm.tzhxq, 10)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.curdForm.tzhsjxl + '')))])])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm + ''))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + ''))])])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '4') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskzc + ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(parseInt(_vm.curdForm.yjhxq, 10)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.yjhteaList), function(tea, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhteaList[i].name + '') + " ===》 " + _vm._s(_vm.tzhteaList[i].name + ''))])])
  }), 0), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.yjhsiteList), function(site, i) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "40px"
      }
    }, [_vm._v(_vm._s(_vm.yjhsiteList[i].name + '') + " ===》 " + _vm._s(_vm.tzhsiteList[i].name + ''))])])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '3') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "补课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.tzhskzc + ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(parseInt(_vm.curdForm.tzhxq, 10)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.curdForm.tzhsjxl + '')))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.tzhskjsxm + ''))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.tzhcdmc + ''))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.adjustFlag == '2') ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "停课时间"
    }
  }, [_c('div', [_c('span', [_vm._v("周数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskzc + ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("星期")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(parseInt(_vm.curdForm.yjhxq, 10)))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', [_vm._v("节数")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.curdForm.yjhsjxl + '')))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课教师"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhskjsxm + ''))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授课地点"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v(_vm._s(_vm.curdForm.yjhcdmc + ''))])])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.curdForm.applyType == '1') ? _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.singleTimeTable()
      }
    }
  }, [_vm._v("课程课表")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.saveInfo()
      }
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == false && _vm.editType != 'show') ? _c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.submitRec()
      }
    }
  }, [_vm._v("提 交")]) : _vm._e(), _vm._v(" "), (_vm.auditDisabled == true && _vm.editType != 'show' && _vm.applyused == false) ? _c('el-button', {
    attrs: {
      "disabled": _vm.applyused,
      "type": "warning",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": function($event) {
        return _vm.auditOption();
      }
    }
  }, [_vm._v("审核意见")]) : _vm._e(), _vm._v(" "), (_vm.editType != 'show') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "50px"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.attachmentVisible,
      "width": "800px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.attachmentVisible = $event
      },
      "close": _vm.closeAttachDialog
    }
  }, [_c('div', {
    staticStyle: {
      "height": "420px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.fileTableLoading),
      expression: "fileTableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "15px"
    },
    attrs: {
      "data": _vm.fileTableData,
      "element-loading-text": "数据加载中",
      "height": _vm.fileTableHeight,
      "stripe": "",
      "border": "",
      "fit": ""
    }
  }, [(_vm.operateAreaVisible) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件名",
      "prop": "fileName",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件类型",
      "prop": "fileType",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.operateAreaVisible),
            expression: "operateAreaVisible"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": _vm.clickUpload
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 上传")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": _vm.confirmDelFile
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除")])], 1), _vm._v(" "), (_vm.viewAreaVisible) ? _c('div', [_vm._v("操作")]) : _vm._e()]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 预览\n                            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.downloadAttachment(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 下载\n                            ")])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "50px"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.uploadDialogVisible,
      "width": "520px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialogVisible = $event
      },
      "close": _vm.closeUploadDialog
    }
  }, [_c('div', {
    staticClass: "attachmentUpload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-upload', {
    ref: "uploadFile",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "file-list": _vm.fileList,
      "http-request": _vm.getFile,
      "multiple": _vm.multipleType,
      "auto-upload": false,
      "limit": 10,
      "on-change": _vm.onChangeFile,
      "on-success": _vm.handleFilUploadSuccess,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                    允许上传的文件类型如下（单个文件大小" + _vm._s(_vm.fileSizeLimit) + "MB以内）"), _c('br'), _vm._v("\n                                    文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx"), _c('br'), _vm._v("\n                                    图片文件：jpg、jpeg、png、gif"), _c('br'), _vm._v("\n                                    音/视频文件：mp3、mp4\n                                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("查看上传文件限制")])], 1)], 1)])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeUploadDialog
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "课程课表",
      "visible": _vm.singleTimeTableVisible,
      "width": "1300px",
      "top": "50px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.singleTimeTableVisible = $event
      },
      "close": _vm.closeTimeTableDialog
    }
  }, [_c('div', {
    staticClass: "maskStyle",
    attrs: {
      "id": "loadingMask_kb"
    }
  }, [_c('div', {
    staticClass: "maskFont"
  }, [_vm._v("验证上课时间中，请稍候...")])]), _vm._v(" "), _c('div', {
    staticClass: "el-dialog-timetable"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v("原课程上课时间")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px",
      "margin-left": "10px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.tkjcChange
    },
    model: {
      value: (_vm.tkjc),
      callback: function($$v) {
        _vm.tkjc = $$v
      },
      expression: "tkjc"
    }
  }, _vm._l((_vm.tkjcInfo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "row-label",
    attrs: {
      "span": 24
    }
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.timetableLoading),
      expression: "timetableLoading"
    }],
    staticClass: "timetable",
    attrs: {
      "element-loading-text": "课表加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.6)"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "timetableTitle separetor",
    attrs: {
      "colspan": "3"
    }
  }), _vm._v(" "), _vm._l((_vm.weekDayName), function(item, index) {
    return _c('td', {
      staticClass: "timetableTitle separetor"
    }, [_vm._v(_vm._s(item))])
  })], 2), _vm._v(" "), (_vm.forenoonNum > 0) ? _c('tr', [_c('td', {
    staticClass: "timetableTitle separetor",
    staticStyle: {
      "width": "3%"
    },
    attrs: {
      "rowspan": _vm.forenoonNum
    }
  }, [_vm._v("上"), _c('br'), _c('br'), _vm._v("午\n                                ")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle",
    staticStyle: {
      "width": "2%"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle",
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v(_vm._s(_vm.timeQuantum[0]))]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
    return _c('td', {
      style: ({
        width: 88 / _vm.weekDayNum + '%'
      }),
      attrs: {
        "id": 'cell_' + (m - 1)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.forenoonNum > 1) ? _vm._l((_vm.forenoonNum - 1), function(n) {
    return _c('tr', [_c('td', {
      class: n < _vm.forenoonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v(_vm._s(n + 1) + "\n                                    ")]), _vm._v(" "), _c('td', {
      class: n < _vm.forenoonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v("\n                                        " + _vm._s(_vm.timeQuantum[n]) + "\n                                    ")]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
      return _c('td', {
        class: n < _vm.forenoonNum - 1 ? '' : 'separetor',
        attrs: {
          "id": 'cell_' + (n * _vm.weekDayNum + m - 1)
        }
      })
    })], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.noonNum > 0) ? _c('tr', [_c('td', {
    staticClass: "timetableTitle separetor",
    attrs: {
      "rowspan": _vm.noonNum
    }
  }, [_vm._v("中"), _c('br'), _c('br'), _vm._v("午")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v(_vm._s(_vm.timeQuantum[_vm.forenoonNum]))]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
    return _c('td', {
      attrs: {
        "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + m - 1)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.noonNum > 1) ? _vm._l((_vm.noonNum - 1), function(n) {
    return _c('tr', [_c('td', {
      class: n < _vm.noonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v(_vm._s(n + 1) + "\n                                    ")]), _vm._v(" "), _c('td', {
      class: n < _vm.noonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v("\n                                        " + _vm._s(_vm.timeQuantum[_vm.forenoonNum + n]) + "\n                                    ")]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
      return _c('td', {
        class: n < _vm.noonNum - 1 ? '' : 'separetor',
        attrs: {
          "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + n * _vm.weekDayNum + m - 1)
        }
      })
    })], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.afternoonNum > 0) ? _c('tr', [_c('td', {
    staticClass: "timetableTitle separetor",
    attrs: {
      "rowspan": _vm.afternoonNum
    }
  }, [_vm._v("下"), _c('br'), _c('br'), _vm._v("午")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v(_vm._s(_vm.timeQuantum[_vm.forenoonNum + _vm.noonNum]))]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
    return _c('td', {
      attrs: {
        "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + _vm.noonNum * _vm.weekDayNum + m - 1)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.afternoonNum > 1) ? _vm._l((_vm.afternoonNum - 1), function(n) {
    return _c('tr', [_c('td', {
      class: n < _vm.afternoonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v("\n                                        " + _vm._s(n + 1) + "\n                                    ")]), _vm._v(" "), _c('td', {
      class: n < _vm.afternoonNum - 1 ? 'timetableTitle' : 'timetableTitle separetor'
    }, [_vm._v("\n                                        " + _vm._s(_vm.timeQuantum[_vm.forenoonNum + _vm.noonNum + n]) + "\n                                    ")]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
      return _c('td', {
        class: n < _vm.afternoonNum - 1 ? '' : 'separetor',
        attrs: {
          "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + _vm.noonNum * _vm.weekDayNum + n * _vm.weekDayNum + m - 1)
        }
      })
    })], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.eveningNum > 0) ? _c('tr', [_c('td', {
    staticClass: "timetableTitle",
    attrs: {
      "rowspan": _vm.eveningNum
    }
  }, [_vm._v("晚"), _c('br'), _c('br'), _vm._v("上")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticClass: "timetableTitle"
  }, [_vm._v(_vm._s(_vm.timeQuantum[_vm.forenoonNum + _vm.noonNum + _vm.afternoonNum]))]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
    return _c('td', {
      attrs: {
        "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + _vm.noonNum * _vm.weekDayNum + _vm.afternoonNum * _vm.weekDayNum + m - 1)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.eveningNum > 1) ? _vm._l((_vm.eveningNum - 1), function(n) {
    return _c('tr', [_c('td', {
      staticClass: "timetableTitle"
    }, [_vm._v(_vm._s(n + 1))]), _vm._v(" "), _c('td', {
      staticClass: "timetableTitle"
    }, [_vm._v(_vm._s(_vm.timeQuantum[_vm.forenoonNum + _vm.noonNum + _vm.afternoonNum + n]))]), _vm._v(" "), _vm._l((_vm.weekDayNum), function(m) {
      return _c('td', {
        attrs: {
          "id": 'cell_' + (_vm.forenoonNum * _vm.weekDayNum + _vm.noonNum * _vm.weekDayNum + _vm.afternoonNum * _vm.weekDayNum + n * _vm.weekDayNum + m - 1)
        }
      })
    })], 2)
  }) : _vm._e()], 2)])], 1)], 1)]), _vm._v(" "), (_vm.detailDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.detailDialogTitle,
      "visible": _vm.detailDialogVisible,
      "width": "600px",
      "top": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "170px"
    }
  }, [_c('audit', {
    key: _vm.timer,
    ref: "audit",
    attrs: {
      "itemCode": _vm.queryForm.itemCode,
      "relatedCode": _vm.selectRowData.id,
      "auditLevel": _vm.curdForm.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "900px",
      "top": "150px"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450,
      "auditFlowInfo": _vm.auditFlowInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.previewerVisible) ? _c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "widthPercent": 60,
      "heightNum": 650,
      "topNum": 60
    },
    on: {
      "closePreviewer": function($event) {
        _vm.previewerVisible = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量导出",
      "visible": _vm.exportDialogVisible,
      "width": "540px",
      "top": "20vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.exportDialogVisible = $event
      },
      "closed": _vm.closeExportDialog
    }
  }, [_c('el-form', {
    ref: "exportForm",
    attrs: {
      "model": _vm.exportForm,
      "label-width": "130px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "学年学期",
      "prop": "xnxqbm"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "学年学期"
    },
    model: {
      value: (_vm.exportForm.xnxqbm),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "xnxqbm", $$v)
      },
      expression: "exportForm.xnxqbm"
    }
  }, _vm._l((_vm.xnxqInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "原计划教师",
      "prop": "teacherCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "原计划教师",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.exportForm.teacherCode),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "teacherCode", $$v)
      },
      expression: "exportForm.teacherCode"
    }
  }, _vm._l((_vm.teacherInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "班级名称",
      "prop": "classCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "班级名称",
      "clearable": "",
      "filterable": ""
    },
    model: {
      value: (_vm.exportForm.classCode),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "classCode", $$v)
      },
      expression: "exportForm.classCode"
    }
  }, _vm._l((_vm.exportClassInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "周次范围",
      "prop": "skzc"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "起始周次",
      "clearable": ""
    },
    model: {
      value: (_vm.exportForm.kszc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "kszc", $$v)
      },
      expression: "exportForm.kszc"
    }
  }, _vm._l((_vm.skzcInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1), _vm._v("\n                         至 \n                        "), _c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "placeholder": "结束周次",
      "clearable": ""
    },
    model: {
      value: (_vm.exportForm.jszc),
      callback: function($$v) {
        _vm.$set(_vm.exportForm, "jszc", $$v)
      },
      expression: "exportForm.jszc"
    }
  }, _vm._l((_vm.skzcInfo), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportAdjustInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }, [_vm._v(" 导出")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b028e1aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/timetableManage/arrange/longtermAdjust.vue
// module id = 1889
// module chunks = 502